import { WebApiRequest, HTTP_GET, HTTP_POST } from "tools/webservice";

export const keepQuickList = (quickListGuid, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_POST,
  endpoint: `/quick-list/${quickListGuid}/keep`,
  successCallback,
  mountedRef,
});

export const copySharedQuickList = (quickListGuid, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_POST,
  endpoint: `/quick-list/${quickListGuid}/copy-shared`,
  successCallback,
  mountedRef,
});

export const getQuickListShareGuid = (quickListId, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_GET,
  endpoint: `/quick-list/${quickListId}/share`,
  successCallback,
  mountedRef,
});

export const getQuickListShareGuidsByGroupName = (groupName, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_GET,
  endpoint: `/quick-list/${btoa(groupName)}/shareGroup`,
  successCallback,
  mountedRef,
});

export const getQuickListByShareGuid = (quickListGuid, successCallback, mountedRef, errorCallback) => WebApiRequest({
  method: HTTP_GET,
  endpoint: `/quick-list/guid/${quickListGuid}`,
  successCallback,
  errorCallback,
  mountedRef,
});

export const copyQuickList = (quickListId, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_POST,
  endpoint: `/quick-list/${quickListId}/copy`,
  successCallback,
  mountedRef,
});

export const getQuickFilterDefs = (successCallback, mountedRef) => WebApiRequest({
  method: HTTP_GET,
  endpoint: `/quick-list/quick-filters/definitions`,
  successCallback,
  mountedRef,
});
